import React from 'react';

import {
  Typography,
  withStyles,
  WithStyles,
  Theme,
  createStyles,
} from '@material-ui/core';
import { IBranding } from '../../types/branding';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'flex-end',
      // textAlign: 'center',
      padding: theme.spacing(2),
    },
    license: {
      flexGrow: 1,
    },
    privacy: {},
  });

interface Props extends WithStyles<typeof styles> {
  privacy?: IBranding['privacy'];
  license?: IBranding['license'];
}

const Footer = ({ privacy, license, classes }: Props) => {
  return (
    <div className={classes.root}>
      <div className={classes.license}>
        {license && (
          <Typography variant="caption">
            All data is released under{' '}
            <a href={license.url} target="_blank" rel="noopener noreferrer">
              {license.label}
            </a>
          </Typography>
        )}
      </div>
      {privacy && (
        <div className={classes.privacy}>
          <Typography variant="caption">
            <a href={privacy.url} target="_blank" rel="noopener noreferrer">
              {privacy.label}
            </a>
          </Typography>
        </div>
      )}
    </div>
  );
};

export default withStyles(styles)(Footer);
